module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Breadcrumb', _vm._l((_vm.$store.state.currentPath), function(item) {
    return _c('BreadcrumbItem', {
      key: item.name,
      attrs: {
        "href": item.path
      }
    }, [_vm._v(_vm._s(item.title) + "\n  ")])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e6d4a37","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/breadcrumb-nav/breadcrumb-nav.vue
// module id = 469
// module chunks = 99